/**
 * 作用于哪些页面
 * 注明代码业务/功能说明
 * @authors kanglimei
 * @date    2018/7/31
 * @version v1.0
 * */
export default{
  showQrcode: function (index) {
    this.miniAppList[index].qrcode = !this.miniAppList[index].qrcode
  },
  hideQrcode: function (index) {
    this.miniAppList[index].qrcode = !this.miniAppList[index].qrcode
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js